<div #boardContainer style="width: 400px; height: 400px"></div>
